import React from 'react';
import ReactDOM from 'react-dom';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogButton } from '@rmwc/dialog';
import { useTranslate } from 'react-polyglot';

/**
 *
 * @param open
 * @param setOpen
 * @param title
 * @param bodyMessage
 * @param functionHandler en el caso de que cuando se le de al boton de cerrar o se haga el escape ejecute algun handler especifico se realiza
 * @param style
 * @returns {*}
 * @constructor
 */
const AlertDialogWarn = ({ 
        open,
        setOpen,
        title,
        bodyMessage,
        functionHandler,
        buttonMessage,
        style
    }) => {
    const t = useTranslate();
    const modalEl = document.getElementById('dialog');

    const onClose = () => {
        if (functionHandler)
            functionHandler();
        setOpen(false)
    }

    return ReactDOM.createPortal(
        <Dialog
            preventOutsideDismiss={true}
            open={open}
            onClose={onClose}
            className={'dialog-alert'}
            {...style}
        >
            <DialogTitle className={'only-close'}>
                <span style={{width: '100%', textAlign: 'left', color: '#FA4E64'}}>{title}</span>
            </DialogTitle>
            <DialogContent>
                {bodyMessage}
            </DialogContent>
            <div className='coa-inner-action-buttons'>
                <DialogActions>
                    <DialogButton
                        className={`coa-dialog-button coa-dialog-button-accept`}
                        action="accept"
                        isDefaultAction
                        onClick={() => {
                            if (functionHandler)
                                functionHandler();
                            setOpen(false)
                        }}
                        >{buttonMessage? buttonMessage:t('actions.close')}
                    </DialogButton>
                </DialogActions>
            </div>
        </Dialog>
        , modalEl)
};

export default AlertDialogWarn;